/** Pixelgipfel booking presentation. BookX owns its buttons, calendar and bookings. */
(function () {
  'use strict';

  if (window.PGBooking) {
    window.PGBooking.init(document);
    return;
  }

  var instances = new Map();
  var rootSelector = '[data-pg-booking]';
  var serviceKeys = ['reparatur', 'upgrade', 'technische-beratung', 'datenrettung'];
  var bookxServices = {
    reparatur: 'tZWuGqgAzVwV7BSSktc5KY',
    upgrade: 'gLgn6n6ZxVuQGhCSMT3DgC',
    'technische-beratung': 'ttzcpSs6xf2MT3y8L4145E',
    datenrettung: 'cNsbKnhhcWde8iPifHau7A'
  };
  var activeTransfer = null;
  var handledNativeClicks = new WeakSet();

  function findRoots(scope) {
    var roots = [];
    if (scope.matches && scope.matches(rootSelector)) roots.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll(rootSelector).forEach(function (root) { roots.push(root); });
    }
    return roots;
  }

  function requestedService() {
    var service = new URLSearchParams(window.location.search).get('service');
    if (service === 'aufbau') service = 'technische-beratung';
    return serviceKeys.indexOf(service) !== -1 ? service : '';
  }

  function requestedCatalogue(root, cards) {
    var items = new URLSearchParams(window.location.search).getAll('service_item');
    if (items.length !== 1 || !items[0]) return null;
    // Match server-rendered catalogue data exactly; never interpolate a URL into a selector.
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-pg-catalog-option]'));
    var matches = options.filter(function (option) {
      return option.getAttribute('data-key') === items[0];
    });
    if (matches.length !== 1) return null;
    var option = matches[0];
    var service = option.getAttribute('data-service');
    var title = option.getAttribute('data-title');
    if (serviceKeys.indexOf(service) === -1 || !title || !title.trim()) return null;
    if (!cards.some(function (card) { return card.getAttribute('data-service') === service; })) return null;
    return { key: items[0], service: service, title: title, price: option.getAttribute('data-price') || '' };
  }

  function watchCatalogueTransfer(card, item) {
    var context = card.querySelector('[data-pg-catalog-context]');
    var status = context && context.querySelector('[data-pg-catalog-transfer-status]');
    if (!status) return function () {};
    // This label is the existing optional BookX question, not a theme-created field.
    var concernLabel = 'Wie können wir Dir helfen?';
    var expectedService = bookxServices[item.service];
    var selection = item.title + (item.price ? ' — ' + item.price : '');
    var session = null;
    var touched = false;
    var disposed = false;

    function report(attribute) {
      status.textContent = attribute ? context.getAttribute(attribute) || '' : '';
      status.hidden = !status.textContent;
    }

    function visible(element) {
      if (!element || !element.isConnected || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      if (!element.getClientRects().length) return false;
      var style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
    }

    function stop(clearStatus) {
      if (session && session.observer) session.observer.disconnect();
      session = null;
      if (activeTransfer === stop) activeTransfer = null;
      if (clearStatus) report();
    }

    function fallback() {
      report('data-transfer-fallback');
      stop(false);
    }

    function currentWidget() {
      var widgets = Array.prototype.slice.call(document.querySelectorAll('bookeasy-widget')).filter(visible);
      if (widgets.length !== 1 || widgets[0].querySelector('.bookeasy-widget-hide')) return null;
      return widgets[0];
    }

    function matchingService(widget) {
      // input is a public Stencil component prop. Read only its service ID;
      // customer details, application stores and provider endpoints are not accessed.
      return widget.input && widget.input.service && widget.input.service.id === expectedService;
    }

    function fieldsIn(customRoot) {
      return Array.prototype.slice.call(customRoot.querySelectorAll('input.bookeasy-input-field')).filter(function (field) {
        return field.name === concernLabel && field.id === concernLabel && field.type === 'text' &&
          field.closest('bookeasy-custom-fields-v2') === customRoot &&
          field.closest('.bookeasy-custom-field-textBox-type') && visible(field);
      });
    }

    function refresh() {
      if (!session || session.writing || !session.widget) return;
      var widget = currentWidget();
      if (widget !== session.widget || !matchingService(widget)) { fallback(); return; }
      var customRoots = Array.prototype.slice.call(widget.querySelectorAll('bookeasy-custom-fields-v2')).filter(visible);
      if (!customRoots.length) return;
      if (customRoots.length !== 1) { fallback(); return; }
      var customRoot = customRoots[0];
      // Wait for BookX's own customFieldsLoaded event to verify this exact form.
      if (!session.forms.has(customRoot)) return;
      var fields = fieldsIn(customRoot);
      if (fields.length !== 1) { fallback(); return; }
      var field = fields[0];
      if (field.disabled || field.readOnly) { fallback(); return; }
      if (touched) { report('data-transfer-preserved'); return; }
      if (field.value !== '') {
        if (session.written && field.value === selection) report('data-transfer-success');
        else { touched = true; report('data-transfer-preserved'); }
        return;
      }
      var attempt = session;
      attempt.writing = true;
      try {
        field.value = selection;
        // BookX's public input component updates its value on change, not input.
        field.dispatchEvent(new Event('change', { bubbles: true }));
        if (session !== attempt) return;
        if (field.isConnected && field.value === selection && matchingService(widget)) {
          attempt.written = true;
          report('data-transfer-success');
        } else fallback();
      } catch (error) {
        fallback();
      } finally {
        attempt.writing = false;
      }
    }

    function onClick(event) {
      var target = event.target;
      var button = target && target.closest && target.closest('.bookeasy-btn');
      if (!button) return;
      // Every mounted catalogue sees this capture event; reset the old session once.
      if (!handledNativeClicks.has(event)) {
        handledNativeClicks.add(event);
        if (activeTransfer) activeTransfer(true);
      }
      // Observe the user's native click. Never forward it or invoke BookX methods.
      if (event.isTrusted !== true || disposed || !card.contains(button)) return;
      var embed = button.closest('[data-pg-booking-native]');
      if (!embed || !card.contains(embed) || button.getAttribute('data-product-id') !== expectedService) return;
      report();
      session = { widget: null, forms: new WeakSet(), observer: null, writing: false, written: false };
      activeTransfer = stop;
    }

    function onEdit(event) {
      if (!session || session.writing || !session.widget) return;
      var field = event.target;
      var customRoot = field && field.closest && field.closest('bookeasy-custom-fields-v2');
      if (!customRoot || !session.widget.contains(customRoot) || !session.forms.has(customRoot)) return;
      if (field.name === concernLabel && field.id === concernLabel) {
        // Keep this opt-out across form re-renders and reopening the same selection.
        touched = true;
        report('data-transfer-preserved');
      }
    }

    function onWidgetEvent(event) {
      if (!session) return;
      var detail = event.detail || {};
      if (detail.type === 'bookNowClicked') { stop(true); return; }
      var element = detail.element;
      if (!element || event.target !== element || !element.closest) return;
      var widget = element.closest('bookeasy-widget');
      if (!widget) return;
      if (detail.type === 'widgetClosed' || detail.type === 'thankYouLoaded') {
        if (!session.widget || widget === session.widget) stop(true);
        return;
      }
      if (widget !== currentWidget()) { fallback(); return; }
      if (!matchingService(widget)) {
        // A newly opened widget may still be waiting for its public input prop.
        if (widget.input && widget.input.service) fallback();
        return;
      }
      if (session.widget && session.widget !== widget) { fallback(); return; }
      if (!session.widget) {
        session.widget = widget;
        session.observer = new MutationObserver(refresh);
        session.observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      }
      if (detail.type === 'footerLoaded' && Array.isArray(detail.availableSteps) && detail.availableSteps.indexOf('CF') === -1) {
        fallback(); return;
      }
      if (detail.type === 'customFieldsLoaded') {
        if (!element.matches('bookeasy-custom-fields-v2') || !Array.isArray(detail.customFields)) { fallback(); return; }
        var questions = detail.customFields.filter(function (question) {
          return question.isEnabled && question.type === 'textBox' && question.label === concernLabel;
        });
        if (questions.length !== 1) { fallback(); return; }
        session.forms.add(element);
      }
      refresh();
    }

    document.addEventListener('click', onClick, true);
    document.addEventListener('bookeasyWidgetEvent', onWidgetEvent);
    document.addEventListener('input', onEdit, true);
    document.addEventListener('change', onEdit, true);
    return function () {
      disposed = true;
      stop(true);
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('bookeasyWidgetEvent', onWidgetEvent);
      document.removeEventListener('input', onEdit, true);
      document.removeEventListener('change', onEdit, true);
    };
  }

  function presentCatalogue(card, item) {
    var context = card.querySelector('[data-pg-catalog-context]');
    if (!context) return function () {};
    var title = context.querySelector('[data-pg-catalog-title]');
    var price = context.querySelector('[data-pg-catalog-price]');
    var copy = context.querySelector('[data-pg-catalog-copy]');
    var status = context.querySelector('[data-pg-catalog-copy-status]');
    if (!title) return function () {};
    var disposed = false;
    var copying = false;
    title.textContent = item.title;
    if (price) {
      price.textContent = item.price;
      price.hidden = !item.price;
    }
    context.hidden = false;
    card.setAttribute('data-pg-catalog-selected', 'true');

    function report(attribute) {
      if (disposed || !status) return;
      status.textContent = context.getAttribute(attribute) || '';
      status.hidden = !status.textContent;
    }

    async function copySelection() {
      if (disposed || copying) return;
      copying = true;
      copy.disabled = true;
      if (status) status.textContent = '';
      try {
        if (!window.navigator || !window.navigator.clipboard || !window.navigator.clipboard.writeText) {
          throw new Error('Clipboard unavailable');
        }
        // This is a deliberate user copy, not a BookX field or booking submission.
        await window.navigator.clipboard.writeText(item.title);
        report('data-copy-success');
      } catch (error) {
        report('data-copy-error');
      } finally {
        copying = false;
        if (!disposed) copy.disabled = false;
      }
    }

    if (copy) copy.addEventListener('click', copySelection);
    return function () {
      disposed = true;
      if (copy) {
        copy.removeEventListener('click', copySelection);
        copy.disabled = false;
      }
      if (status) {
        status.textContent = '';
        status.hidden = true;
      }
      context.hidden = true;
      card.removeAttribute('data-pg-catalog-selected');
    };
  }

  function watchNative(embed, heading) {
    var status = embed.querySelector('[data-pg-booking-status]');
    var translatedLabel = embed.getAttribute('data-pg-booking-label');
    var timer = null;
    var slow = false;
    var disposed = false;

    function refresh() {
      if (disposed) return;
      var buttons = embed.querySelectorAll('.bookeasy-btn');
      buttons.forEach(function (button) {
        // BookX's configured German idle label is independent of the storefront locale.
        // Keep the native button, handlers, icons and changing app states intact.
        var nativeLabel = button.querySelector('.bookeasy-button-text');
        if (nativeLabel && translatedLabel && nativeLabel.textContent.replace(/\s+/g, ' ').trim() === 'Termin buchen' && nativeLabel.textContent !== translatedLabel) {
          nativeLabel.textContent = translatedLabel;
        }
        var label = button.textContent.replace(/\s+/g, ' ').trim();
        var service = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
        if (label && service) {
          var contextualLabel = label + ': ' + service;
          if (button.getAttribute('aria-label') !== contextualLabel) {
            button.setAttribute('aria-label', contextualLabel);
          }
        }
      });

      if (!status) return;
      if (buttons.length) {
        status.hidden = true;
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
        slow = false;
        return;
      }

      status.hidden = false;
      var message = status.getAttribute(slow ? 'data-slow' : 'data-loading');
      if (message && status.textContent !== message) status.textContent = message;
      if (timer === null && !slow) {
        timer = window.setTimeout(function () {
          timer = null;
          slow = true;
          refresh();
        }, 12000);
      }
    }

    var observer = new MutationObserver(refresh);
    observer.observe(embed, { childList: true, subtree: true, characterData: true });
    refresh();

    return function () {
      disposed = true;
      observer.disconnect();
      if (timer !== null) window.clearTimeout(timer);
    };
  }

  function initRoot(root) {
    if (instances.has(root)) return;
    var cleanup = [];
    instances.set(root, cleanup);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pg-booking-card]'));
    var catalogue = requestedCatalogue(root, cards);
    var requested = catalogue ? catalogue.service : requestedService();
    var selected = requested && cards.find(function (card) {
      return card.getAttribute('data-service') === requested;
    });

    if (selected) {
      // Move the existing node: native app state and tab order stay together.
      if (root.firstElementChild !== selected) root.insertBefore(selected, root.firstElementChild);
      selected.setAttribute('data-selected', 'true');
      var badge = selected.querySelector('[data-pg-booking-selected]');
      if (badge) badge.hidden = false;
      if (catalogue) {
        cleanup.push(presentCatalogue(selected, catalogue));
        cleanup.push(watchCatalogueTransfer(selected, catalogue));
      }
      var heading = selected.querySelector('[data-pg-booking-heading]');
      if (heading && root.getAttribute('data-focus-selection') === 'true') heading.focus();
      cleanup.push(function () {
        selected.removeAttribute('data-selected');
        if (badge) badge.hidden = true;
      });
    }

    cards.forEach(function (card) {
      var heading = card.querySelector('[data-pg-booking-heading]');
      card.querySelectorAll('[data-pg-booking-native]').forEach(function (embed) {
        cleanup.push(watchNative(embed, heading));
      });
    });
  }

  function init(scope) {
    findRoots(scope).forEach(initRoot);
  }

  function unload(scope) {
    findRoots(scope).forEach(function (root) {
      var cleanup = instances.get(root);
      if (!cleanup) return;
      cleanup.forEach(function (dispose) { dispose(); });
      instances.delete(root);
    });
  }

  window.PGBooking = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
